import { render, staticRenderFns } from "./setupPayroll.vue?vue&type=template&id=8eafb57a&scoped=true"
import script from "./setupPayroll.vue?vue&type=script&lang=js"
export * from "./setupPayroll.vue?vue&type=script&lang=js"
import style0 from "./setupPayroll.vue?vue&type=style&index=0&id=8eafb57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eafb57a",
  null
  
)

export default component.exports